import React from 'react';
import { ChipProps } from '..';

export const getChipVariant = (variant: ChipProps['variant'], active?: boolean) => {

  if (typeof active !== 'boolean') return variant;

  if (active) {
    return variant === 'filled' ? variant : 'tonalOutlined';
  }
  return variant || 'default';
};

export const getChipBadgeVariant = (chipVariant: ChipProps['variant'], active?: boolean) => {
  if (typeof active !== 'boolean') {
    return (chipVariant === 'tonal' || chipVariant === 'tonalOutlined') ? 'standard' : 'tonal';
  }

  return active ? 'standard' : 'tonal';
};

export const hasContent = (value?: React.ReactNode) => {
  return (typeof value === 'string' && value.trim().length) || React.Children.count(value) > 0;
};